/** Admin `trek_schedule_days.count_as_day`: 0 = pre-trip leg (show Day 0); 1 = counts toward trip days. */
export function readScheduleCountAsDay(day) {
  if (day == null) return 1;
  const raw = day.countAsDay ?? day.count_as_day;
  if (raw == null || raw === '') return 1;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 1;
}

/**
 * Display day label per itinerary row (same order as filtered scheduleDays).
 * countAsDay 0 → Day 0; each later row with countAsDay ≠ 0 → Day 1, 2, 3…
 */
export function buildItineraryDisplayDayNumbers(scheduleDays) {
  let tripDay = 0;
  return (scheduleDays || []).map((day) => {
    if (readScheduleCountAsDay(day) === 0) return 0;
    tripDay += 1;
    return tripDay;
  });
}

/** Trip length for package cards: max itinerary day (Day 0 rows do not add). */
export function countItineraryTripDays(scheduleDays) {
  const nums = buildItineraryDisplayDayNumbers(scheduleDays || []);
  if (!nums.length) return 0;
  return Math.max(...nums);
}

/**
 * Calendar offset from package/batch start date.
 * Day 0 → −1 (e.g. depart day before camp start); Day 1 → 0 (start date); Day 2 → +1 …
 */
export function itineraryDateOffsetFromDisplayDay(displayDayNumber) {
  const n = Number(displayDayNumber);
  if (!Number.isFinite(n)) return 0;
  return n - 1;
}
